"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

require("../../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DragDropColumn = _interopRequireDefault(require("./DragDropColumn"));

var _MultiDragRow = _interopRequireDefault(require("./MultiDragRow"));

var _MultiDragReducer = require("./MultiDragReducer.js");

var _reMutable = _interopRequireDefault(require("re-mutable"));

var _FormSearchBox = _interopRequireDefault(require("../../forms/FormSearchBox"));

var _InputRow = _interopRequireDefault(require("../../layout/InputRow"));

var _underscore = _interopRequireDefault(require("underscore"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context6; _forEachInstanceProperty(_context6 = ownKeys(Object(source))).call(_context6, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @typedef {object} MultiDrag~IndexesDescriptor
 *
 * @property {number} from
 *    The index of the dragged row.
 * @property {number} to
 *    The index of the destination row.
 */

/**
 * @function MultiDrag.convertFilteredIndexes
 * @desc When dragging items to and from a filtered list, the to/from indexes the the component reports
 *    won't accurately describe what the underlying move in the unfiltered list should look like.
 *    We have to do some logic to convert back the indexes relative to the unfiltered rows.
 *
 * @param {MultiDrag~ColumnData[]} columns
 *    The data representing the columns in the component.
 * @param {MultiDrag~MoveDescriptor} desc
 *    The move descriptor for the drag.
 *
 * @return {MultiDrag~IndexesDescriptor}
 *    The indexes descriptor for the drag with the indexes converted.
 */
function convertFilteredIndexes(columns, desc) {
  var _context, _context2;

  //find the index in the unfiltered columns
  var from = (0, _indexOf.default)(_context = columns[desc.from.column].rows).call(_context, columns[desc.from.column].filteredRows[desc.from.index]);
  var to = desc.to.index >= columns[desc.to.column].filteredRows.length //if an item is being dragged to the end of the list, append it to the end of the unfiltered list
  ? columns[desc.to.column].rows.length : (0, _indexOf.default)(_context2 = columns[desc.to.column].rows).call(_context2, columns[desc.to.column].filteredRows[desc.to.index]);
  return {
    from: from,
    to: to
  };
}
/**
 * @typedef {object} MultiDrag~ColumnData
 *
 * @property {string} labelEmpty
 *    Empty label for the column. Overrides labelEmpty prop for the component as a whole, but falls back
 *    on that prop if not provided.
 * @property {string} name
 *    The name of the column.
 * @property {object[]} rows
 *    An array of objects that constintute the rows. These are free to have any shape,
 *    remember that this will correspond to the props that will be injected to each row when rendering them.
 * @property {string} [filter]
 *    A filter to display for the column.
 */

/**
 * @typedef {object} MultiDrag~MoveObject
 *
 * @property {number} column
 *    The dragged/target column index.
 * @property {number} index
 *    The index dragged from/to.
 * @property {number} [convertedIndex]
 *    The index dragged from/to, converted from filtered to unfiltered index if filtering is applied;
 *    only supplied by stateful implemenation.
 */

/**
 * @typedef {object} MultiDrag~MoveDescriptor
 *
 * @property {MultiDrag~MoveObject} from
 *    The dragged item location description.
 * @property {MultiDrag~MoveObject} to
 *    The target item location description.
 */

/**
* @typedef {object} MultiDrag~previewLocation
*
* @property {number} column
*    The column index of the preview.
* @property {number} row
*    The row index of the preview.
*/

/**
* @callback MultiDrag~onSearch
*
* @param {number} index
*    Since the multi-Drag component supports search in all columns,
*    each column needs to report which column (via the column index) a search affects.
* @param {string} value
*    The value to search for.
*/

/**
* @callback MultiDrag~onDragDrop
*
* @param {MultiDrag~MoveDescriptor} moveDescriptor
*    The move descriptor for the drag.
*/

/**
* @callback MultiDrag~onCancel
*/

/**
* @callback MultiDrag~onScrolledToPosition
*
* @param {number} columnIndex
*     The column index for the column scrolled.
*/

/**
* @callback MultiDrag~onDragStart
*/

/**
* @callback MultiDrag~onDragEnd
*/

/**
 * @class MultiDrag
 * @desc A multi-column drag and drop view. This is designed to allow more than two columns though,
 *    the requirements only specify 2 columns needed. The consumer of the component is responsible for implementing
 *    the component type for each row. The component will iterate over a set of data and coerce each item to a
 *    row component.
 *
 * @param {string} [data-id="multi-drag"]
 *    To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *    CSS classes to set on the top-level HTML container.
 * @param {boolean} [stateless]
 *     To enable the component to be externally managed. True will relinquish control to the component's owner.
 *     False or not specified will cause the component to manage state internally.
 *     stateless=false will handle filtering and moving in addition to executing all callbacks if specified.
 *
 * @param {MultiDrag~ColumnData[]} columns
 *    The data representing the columns in the component.
 * @param {MultiDrag~previewLocation} [previewMove]
 *    If passed, will render a placeholder in MultiDrag~previewLocation specified.
 *    This is used to give feedback when a user drags a row to a new location but has not released the mouse.
 * @param {string[]} [classNames]
 *    The classnames to assign to each column.
 *    By default the first column will have row-selector__available applied and the second row-selector__added.
 * @param {boolean} [showSearchOnAllColumns=false]
 *    Display searchbar on all columns.
 * @param {boolean} [showSearch=false]
 *    Display searchbar on the first column.
 * @param {object} [rightAccessories]
 *    Display accessories to the right of the search bar, must be used in conjunction with search bar.
 * @param {boolean} [showCategoryFilterOnAllColumns=false]
 *    Display category list on all columns.
 * @param {boolean} [showCategoryFilter=false]
 *    Display category list on the first column.
 * @param {string[]} [filterFieldNames=[]]
 *    An array of field names of the row properties to use in a search where array index corresponds to each column index.
 *    If unset for any column index, search will use all row properties that have a string representation for that column.
 *    Only used when stateless=false.
 *
 * @param {boolean} [autoFocus=false]
 *     Whether or not to auto-focus the element.
 * @param {boolean} [disabled=false]
 *    Disables the MultiDrag component
 * @param {string} [labelEmpty]
 *    Sets the text for the right column when no items are added
 * @param {array} [categoryList]
 *    The list of categories that you can filter rows by
 * @param {object} contentType
 *    A react component to be used as a template for rendering rows. Can also be a function that returns JSX;
 *    function is passed all of the props of the column, including its handlers.
 *
 * @param {MultiDrag~onSearch} onSearch
 *    Callback to be triggered when a column is searched. When stateless=false, will be executed after search has
 *    completed and the component re-renders.
 * @param {MultiDrag~onDragDrop} onDrag
 *    Callback to be triggered when a row is dragged. When stateless=false, will be executed after drag has
 *    completed and the component re-renders.
 * @param {MultiDrag~onDragDrop} onDrop
 *    Callback to be triggered when a row id dropped. When stateless=false, will be executed after drop has
 *    completed and the component re-renders.
 * @param {MultiDrag~onCancel} onCancel
 *    Callback to be triggered when a drag event ends. When stateless=false, will be executed after cancel has
 *    completed and the component re-renders.
 * @param {MultiDrag~onScrolledToPosition} [onScrolledToTop]
 *    Callback to be triggered when the list is scrolled to the top. Can be used to fetch more data.
 * @param {MultiDrag~onScrolledToPosition} [onScrolledToBottom]
 *    Callback to be triggered when the list is scrolled to the bottom. Can be used to fetch more data.
 *
 * @param {MultiDrag~onDragStart} [onDragStart]
 *    Callback to be triggered when a drag event starts.
 * @param {MultiDrag~onDragEnd} [onDragEnd]
 *    Callback to be triggered when a drag even ends.
 * @param {MultiDrag~customSort} [customSort]
 *    Callback to sort rows according to custom criteria. Expects to receive rows as a return value.
 *
 * @example
 *    <MultiDrag
 *        showSearchOnAllColumns={this.props.demo.search === "all"}
 *        showSearch={this.props.demo.search === "first"}
 *        onSearch={this.onSearch}
 *        columns={this.props.drag.columns}
 *        previewMove={this.props.drag.placeholder}
 *        onScrolledToTop={this.onScrolledToTop}
 *        onScrolledToBottom={this.onScrolledToBottom}
 *        onCancel={this.onCancel}
 *        onDrop={this.onDrop}
 *        onDrag={this.onDrag}
 *        contentType={contentType}
 *    />
 */


var MultiDragStateless = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(MultiDragStateless, _React$Component);

  var _super = _createSuper(MultiDragStateless);

  function MultiDragStateless() {
    var _context3;

    var _this;

    (0, _classCallCheck2.default)(this, MultiDragStateless);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context3 = [this]).call(_context3, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_changedSinceLastDrag", function (targetIndex, beingDraggedIndex, targetColumn, beingDraggedColumn) {
      if (_this._lastDrag && _this._lastDrag.from.column === beingDraggedColumn && _this._lastDrag.from.index === beingDraggedIndex && _this._lastDrag.to.column === targetColumn && _this._lastDrag.to.index === targetIndex) {
        return null;
      }

      return {
        from: {
          column: beingDraggedColumn,
          index: beingDraggedIndex
        },
        to: {
          column: targetColumn,
          index: targetIndex
        }
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_isValidDrag", function () {
      return !(_this._lastDrag && _this._lastDrag.from.column === _this._lastDrag.to.column && _this._lastDrag.from.index - _this._lastDrag.to.index === 0);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onCancel", function (droppedInContainer) {
      // only apply drop if row dragged within a valid drop target
      // otherwise you can't cancel a drag that has started
      if (_this._lastDrag && _this._isValidDrag() && droppedInContainer) {
        _this.props.onDrop(_this._lastDrag);
      }

      _this._lastDrag = null;

      _this.props.onCancel();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onDrag", function (targetIndex, beingDraggedIndex, targetColumn, beingDraggedColumn) {
      //eslint-disable-line
      var desc = _this._changedSinceLastDrag(targetIndex, beingDraggedIndex, targetColumn, beingDraggedColumn); // if nothing has changed, dont execute the callback


      if (!desc || typeof targetIndex === "undefined") {
        return;
      }

      _this._lastDrag = desc;

      if (_this._isValidDrag()) {
        _this.props.onDrag(desc);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onDrop", function () {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderColumn", function (column, index) {
      var _ref = _this.props.previewMove || {},
          prevColumn = _ref.column,
          prevIndex = _ref.index;

      var ghostRowAt = prevColumn === index ? prevIndex : null; // don't increment if ghostRowAt is null, otherwise a preview row
      // gets created in each column.
      // not applicable if from or to index is for a different column.

      if (_this._lastDrag && _this._lastDrag.from.index < _this._lastDrag.to.index && _this._lastDrag.from.column === _this._lastDrag.to.column && ghostRowAt !== null) {
        ghostRowAt += 1;
      }

      var showCategoryFilter = _this.props.showCategoryFilter && index === 0 || _this.props.showCategoryFilterOnAllColumns;
      var categoryList = showCategoryFilter ? _this.props.categoryList : null;

      var contentType = _this.props.contentType || /*#__PURE__*/_react.default.createElement(_MultiDragRow.default, {
        onRemove: _this.props.onRemove,
        onAdd: _this.props.onAdd
      });

      return /*#__PURE__*/_react.default.createElement(_DragDropColumn.default // Columns can have their own labelEmpty; this lets this.props.labelEmpty
      // be the default
      , (0, _extends2.default)({
        rowCount: _this.props.rowCount,
        labelEmpty: _this.props.labelEmpty
      }, column, {
        categoryList: categoryList,
        key: index,
        index: index,
        disableSort: index === 0,
        rows: column.filteredRows,
        onScrolledToBottom: _this.props.onScrolledToBottom,
        onScrolledToTop: _this.props.onScrolledToTop,
        onDrag: _this._onDrag,
        onDrop: _this._onDrop,
        onDragStart: _this.props.onDragStart,
        onDragEnd: _this.props.onDragEnd,
        onCancel: _this._onCancel,
        onCategoryClick: _this.props.onCategoryClick,
        onCategoryToggle: _this.props.onCategoryToggle,
        onAdd: _this.props.onAdd,
        onRemove: _this.props.onRemove,
        ghostRowAt: ghostRowAt,
        dragToEdge: true,
        className: _this.props.classNames[index],
        contentType: contentType,
        "data-id": "DragDropColumn-" + index,
        showCount: index > 0,
        strings: _this.props.strings
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderSearch", function (column, index) {
      var handleSearch = function handleSearch(value) {
        return _this.props.onSearch(index, value);
      };

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormSearchBox.default, {
        "data-id": "search-".concat(index),
        key: "search-".concat(index),
        onValueChange: handleSearch,
        className: "input-search row-selector__search",
        placeholder: "Search ".concat(column.searchName || column.name),
        showClear: true,
        autoFocus: _this.props.autoFocus,
        value: column.search
      }), _this.props.rightAccessories ? /*#__PURE__*/_react.default.createElement("div", {
        className: "row-selector__right-accessories"
      }, _this.props.rightAccessories) : "");
    });
    return _this;
  }

  (0, _createClass2.default)(MultiDragStateless, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = (0, _classnames.default)("row-selector", this.props.className, {
        "row-selector--disabled": this.props.disabled
      });
      var _this$props = this.props,
          columns = _this$props.columns,
          dataId = _this$props["data-id"],
          showSearch = _this$props.showSearch,
          showSearchOnAllColumns = _this$props.showSearchOnAllColumns;
      return /*#__PURE__*/_react.default.createElement(_InputRow.default, {
        "data-id": dataId,
        className: className
      }, /*#__PURE__*/_react.default.createElement("div", {
        key: "search-row",
        className: "row-selector__search-row"
      }, (0, _map.default)(columns).call(columns, function (column, index) {
        return showSearch && index === 0 || showSearchOnAllColumns ? _this2._renderSearch(column, index) //create empty column to size single search column.
        :
        /*#__PURE__*/
        _react.default.createElement("div", {
          key: "search" + column.name,
          className: "row-selector__search"
        });
      })), /*#__PURE__*/_react.default.createElement("div", {
        key: "columns",
        className: "row-selector__columns"
      }, (0, _map.default)(columns).call(columns, this._renderColumn)));
    }
  }]);
  return MultiDragStateless;
}(_react.default.Component);

(0, _defineProperty2.default)(MultiDragStateless, "displayName", "MultiDragStateless");
(0, _defineProperty2.default)(MultiDragStateless, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    labelEmpty: _propTypes.default.string,
    name: _propTypes.default.string,
    filter: _propTypes.default.string,
    rows: _propTypes.default.array
  })).isRequired,
  rightAccessories: _propTypes.default.object,
  showSearchOnAllColumns: _propTypes.default.bool,
  showSearch: _propTypes.default.bool,
  showCategoryFilterOnAllColumns: _propTypes.default.bool,
  showCategoryFilter: _propTypes.default.bool,
  // react doesn't wrap the PropTypes.shape validator with,
  // so can't specify shape of object for previewMove otherwise it won't re-render
  previewMove: _propTypes.default.object,
  categoryList: _propTypes.default.arrayOf(_propTypes.default.string),
  contentType: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  classNames: _propTypes.default.arrayOf(_propTypes.default.string),
  // callbacks
  onSearch: _propTypes.default.func.isRequired,
  onDrag: _propTypes.default.func.isRequired,
  onDrop: _propTypes.default.func.isRequired,
  onCancel: _propTypes.default.func.isRequired,
  onScrolledToBottom: _propTypes.default.func,
  onScrolledToTop: _propTypes.default.func,
  // optional items
  autoFocus: _propTypes.default.bool,
  labelEmpty: _propTypes.default.string,
  customSort: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  onDragStart: _propTypes.default.func,
  onDragEnd: _propTypes.default.func,
  strings: _propTypes.default.objectOf(_propTypes.default.string)
});
(0, _defineProperty2.default)(MultiDragStateless, "defaultProps", {
  "data-id": "multi-drag",
  classNames: ["row-selector__available", "row-selector__added"],
  showSearchOnAllColumns: false,
  showSearch: false,
  autoFocus: false,
  disabled: false,
  showCategoryFilter: true,
  showCategoryFilterOnAllColumns: false,
  strings: {}
});

var MultiDragStateful = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2.default)(MultiDragStateful, _React$Component2);

  var _super2 = _createSuper(MultiDragStateful);

  function MultiDragStateful() {
    var _context4;

    var _this3;

    (0, _classCallCheck2.default)(this, MultiDragStateful);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super2.call.apply(_super2, (0, _concat.default)(_context4 = [this]).call(_context4, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "state", {
      columns: _this3.props.columns,
      placeholder: null,
      showCategoryList: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "_handleSearch", function (index, value) {
      _this3.setState((0, _MultiDragReducer.search)(_this3.state, {
        column: index,
        filter: value,
        fieldName: _this3.props.filterFieldNames[index] || "name"
      }), function () {
        if (this.props.onSearch) {
          this.props.onSearch(index, value);
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "_handleAdd", function (from) {
      if (_this3.props.onAdd) {
        _this3.props.onAdd(from);
      } else {
        _this3._handleDrop({
          from: from,
          to: {
            column: 1,
            index: 0
          }
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "_handleCategoryToggle", function (index) {
      var showing = _this3.state.columns[index].showCategoryList || false;

      _this3.setState((0, _reMutable.default)(_this3.state).set(["columns", index, "showCategoryList"], !showing).end());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "_handleCategoryClick", function (index, value) {
      // use remutable to set state.colums[index].category to the new value
      var next = (0, _reMutable.default)(_this3.state).set(["columns", index, "category"], value).end();

      _this3.setState( // update the filteredRows
      (0, _MultiDragReducer.reapplyFilters)(next, _this3.props.customSort), function () {
        if (this.props.onCategoryClick) {
          this.props.onCategoryClick(index, value);
        }

        this._handleCategoryToggle(index);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "_handleCancel", function () {
      _this3.setState({
        placeholder: null
      }, function () {
        if (_this3.props.onCancel) {
          _this3.props.onCancel();
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "_handleDrop", function (desc) {
      var _convertFilteredIndex = convertFilteredIndexes(_this3.state.columns, desc),
          convertedFrom = _convertFilteredIndex.from,
          convertedTo = _convertFilteredIndex.to;

      var from = desc.from,
          to = desc.to; // reapply filters after a move so moved rows filtered as well

      var next = (0, _MultiDragReducer.reapplyFilters)((0, _MultiDragReducer.move)(_this3.state, {
        from: {
          column: from.column,
          index: convertedFrom
        },
        to: {
          column: to.column,
          index: convertedTo
        }
      }), _this3.props.customSort);

      _this3.setState(next, function () {
        if (_this3.props.onDrop) {
          _this3.props.onDrop({
            from: _objectSpread({
              convertedIndex: convertedFrom
            }, from),
            to: _objectSpread({
              convertedIndex: convertedTo
            }, to)
          }, next.columns);
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "_handleDrag", function (desc) {
      return _this3.setState({
        placeholder: desc.to
      }, function () {
        if (_this3.props.onDrag) {
          _this3.props.onDrag(desc, _this3.props.columns);
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "_handleRemove", function (from) {
      if (_this3.props.onRemove) {
        _this3.props.onRemove(from);
      } else {
        _this3._handleDrop({
          from: from,
          to: {
            column: 0,
            index: 0
          }
        });
      }
    });
    return _this3;
  }

  (0, _createClass2.default)(MultiDragStateful, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      // apply any initial filters
      this.setState(_objectSpread({}, (0, _MultiDragReducer.reapplyFilters)(this.state, this.props.customSort)));
    }
  }, {
    key: "componentWillReceiveProps",

    /* istanbul ignore next */
    value: function componentWillReceiveProps(_ref2) {
      var _this4 = this;

      var nextCols = _ref2.columns,
          customSort = _ref2.customSort;

      if (!_underscore.default.isEqual(nextCols, this.props.columns) || !_underscore.default.isEqual(customSort, this.props.customSort)) {
        this.setState(function (prevState) {
          return (0, _MultiDragReducer.reapplyFilters)(prevState, customSort || _this4.props.customSort);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(MultiDragStateless, _objectSpread(_objectSpread({}, this.props), {}, {
        ref: "MultiDragStateless",
        onSearch: this._handleSearch,
        onCategoryClick: this._handleCategoryClick,
        onCategoryToggle: this._handleCategoryToggle,
        columns: this.state.columns,
        previewMove: this.state.placeholder,
        onAdd: this._handleAdd,
        onCancel: this._handleCancel,
        onDrop: this._handleDrop,
        onDrag: this._handleDrag,
        onRemove: this._handleRemove
      }));
    }
  }]);
  return MultiDragStateful;
}(_react.default.Component);

(0, _defineProperty2.default)(MultiDragStateful, "displayName", "MultiDragStateful");
(0, _defineProperty2.default)(MultiDragStateful, "propTypes", {
  filterFieldNames: _propTypes.default.arrayOf(_propTypes.default.string)
});
(0, _defineProperty2.default)(MultiDragStateful, "defaultProps", {
  filterFieldNames: []
});

var MultiDrag = /*#__PURE__*/function (_React$Component3) {
  (0, _inherits2.default)(MultiDrag, _React$Component3);

  var _super3 = _createSuper(MultiDrag);

  function MultiDrag() {
    (0, _classCallCheck2.default)(this, MultiDrag);
    return _super3.apply(this, arguments);
  }

  (0, _createClass2.default)(MultiDrag, [{
    key: "render",
    value: function render() {
      return this.props.stateless ? /*#__PURE__*/_react.default.createElement(MultiDragStateless, (0, _extends2.default)({}, this.props, {
        ref: "MultiDragStateless"
      })) : /*#__PURE__*/_react.default.createElement(MultiDragStateful, (0, _extends2.default)({}, this.props, {
        ref: "MultiDragStateful"
      }));
    }
  }]);
  return MultiDrag;
}(_react.default.Component);

(0, _defineProperty2.default)(MultiDrag, "displayName", "MultiDrag");
(0, _defineProperty2.default)(MultiDrag, "propTypes", {
  stateless: _propTypes.default.bool
});
(0, _defineProperty2.default)(MultiDrag, "defaultProps", {
  stateless: false
});
MultiDrag.MultiDragRow = _MultiDragRow.default;
MultiDrag.Reducer = require("./MultiDragReducer");
MultiDrag.Actions = require("./MultiDragActions");
MultiDrag.convertFilteredIndexes = convertFilteredIndexes;
module.exports = MultiDrag;